<template>
  <v-form>
    <v-card>
      <v-card-title>
        <span class="headline" v-if="!profile.id"
          >New profile (create user)</span
        >
        <v-layout v-else column ma-0>
          <span class="headline">Edit "{{ profile.email }}"</span>
          <span style="font-size: 16px">{{ profile.id }}</span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn text icon @click.prevent="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs
          v-model="currentTab"
          active-class="selected-tab"
          fixed-tabs
          background-color="#EEE"
        >
          <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab key="1" href="#tab-1">General</v-tab>
          <v-tab key="2" href="#tab-2">Orders</v-tab>
          <v-tab key="3" href="#tab-3">Invoices</v-tab>
          <v-tab key="4" href="#tab-4">Addresses</v-tab>
          <v-tab key="5" href="#tab-5">Payment Methods</v-tab>

          <v-tabs-items v-model="currentTab">
            <v-tab-item key="1" value="tab-1">
              <profile-info :profile="profile"></profile-info>
            </v-tab-item>

            <v-tab-item key="2" value="tab-2">
              <profile-orders :uid="profile.id"></profile-orders>
            </v-tab-item>

            <v-tab-item key="3" value="tab-3">
              <profile-invoices :uid="profile.id"></profile-invoices>
            </v-tab-item>

            <v-tab-item key="4" value="tab-4">
              <profile-addresses :uid="profile.id"></profile-addresses>
            </v-tab-item>

            <v-tab-item key="5" value="tab-5">
              <profile-sources :uid="profile.id"></profile-sources>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click.prevent="closeModal"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
//import fb from "@/firebase";
//import { mapMutations } from "vuex";

import ProfileInfo from "@/views/ProfileInfo";
import ProfileOrders from "@/views/ProfileOrders";
import ProfileInvoices from "@/views/ProfileInvoices";
import ProfileAddresses from "@/views/ProfileAddresses";
import ProfileSources from "@/views/ProfileSources";

export default {
  name: "ProfileView",
  props: {
    profile: Object
  },
  data: () => ({
    currentTab: "tab-1",
    loading: false
  }),
  components: {
    ProfileInfo,
    ProfileOrders,
    ProfileInvoices,
    ProfileAddresses,
    ProfileSources
  },
  mounted: function() {},
  watch: {},
  methods: {
    //updateItem(item) {},
    closeModal() {
      //this.offer.name = "";
      //this.offer.frontChannelId = "";
      this.$emit("close");
    }
  }
};
</script>
